import React from "react"
import { compose, withProps, withStateHandlers } from "recompact"
import { Field } from "redux-form"
import entityApi from "src/hocs/entity"
import resourceTypeModel from "src/models/resourceType"
import Input from "src/components/Input"
import { reduxForm } from "src/engine/modules/entity/plugins"
import withQueryParams from "src/hocs/withQueryParams"
import FieldSet from "@infotech/uikit-fieldset"
import queryString from "query-string"
import withSideModalPending from "src/hocs/withSideModalPending"
import { PrimaryButton, SecondaryButton } from "@infotech/uikit-button"
import ModalConfirm from "src/components/modals/ModalConfirm"
import LinkContent from "src/components/LinkContent"
import { Box } from "@infotech/uikit-grid"
import { RESOURCE_TYPES_URL } from "src/constants/routeNames"
import get from "lodash/get"
import noop from "lodash/noop"
import { P } from "@infotech/uikit-text"
import GridFields from "./GridFields"
import styles from "./styles.css"

export const FORM_NAME = `createResourceType`
const getTestAttribute = name => `planner-resource-types-item-${name}`

const enhancer = compose(
  withQueryParams(),
  withProps(({ match, disableEdit }) => {
    const isNew = match.params.id === `new`
    return {
      isDisabled: disableEdit && !isNew,
    }
  }),
  withStateHandlers(
    () => ({
      isConfirmationModalOpen: false,
    }),
    {
      openConfirmationModal: () => () => ({
        isConfirmationModalOpen: true,
      }),
      closeConfirmationModal: () => () => ({
        isConfirmationModalOpen: false,
      }),
    },
  ),
  withProps(({ history, queryParams }) => ({
    onClose: () =>
      history.push(
        `${RESOURCE_TYPES_URL}/${queryString.stringify(queryParams)}`,
      ),
  })),
  entityApi({
    to: `resourceType`,
    model: resourceTypeModel,
    onCreate: ({ history, queryParams }) => ({ id }) => {
      history.push(
        `${RESOURCE_TYPES_URL}/${id}?${queryString.stringify(queryParams)}`,
      )
    },
    plugins: [
      /* Support redux form, all linking logic between entity module and redux
       * form has stashed in this plugin */
      reduxForm(
        withProps(({ workspace: { emit } }) => ({
          form: FORM_NAME,
          onSubmit(
            data,
            dispatch,
            {
              resourceType: {
                api: { save },
              },
            },
          ) {
            emit(`save`)
            return save(data)
          },
        })),
      ),
    ],
  }),
  withSideModalPending(`resourceType`, `Тип ресурса не найден`, true),
)

export default enhancer(props => {
  const {
    resourceType,
    resourceType: { id, isVirtual },
    handleSubmit,
    isDisabled,
    disableEdit,
    dirty,
    change,
    initialValues,
    isConfirmationModalOpen,
    openConfirmationModal,
    closeConfirmationModal,
    onClose,
  } = props

  const isNew = Boolean(!Number(id))
  const isDisabledByPermission = disableEdit && !isNew
  const haveLink = Boolean(get(resourceType, `data.externalLinkTemplate`))

  return (
    <Box loose flex>
      <Box loose className={styles.ContentColumn}>
        <Box loose className={styles.ContentWrapper} pl="2md" pr="2md">
          <Box loose pt="2md">
            <div data-testid={getTestAttribute(`name`)}>
              <FieldSet caption="Наименование типа ресурса" required>
                <Field
                  component={Input}
                  name="name"
                  props={{
                    placeholder: `Введите наименование типа ресурса`,
                    disabled: isDisabled,
                  }}
                />
              </FieldSet>
            </div>
          </Box>
          <Box loose>
            <div data-testid={getTestAttribute(`labelTemplate`)}>
              <FieldSet caption="Шаблон параметров ресурса">
                <Field
                  component={Input}
                  name="labelTemplate"
                  props={{
                    placeholder: `Введите шаблон параметров ресурса`,
                    disabled: isDisabled,
                  }}
                />
              </FieldSet>
            </div>
          </Box>
          <Box loose>
            <div data-testid={getTestAttribute(`code`)}>
              <FieldSet caption="Код" required>
                <Field
                  component={Input}
                  name="code"
                  props={{
                    placeholder: `Введите код`,
                    disabled: isDisabled,
                  }}
                />
              </FieldSet>
            </div>
          </Box>
          <Box loose mt="-1md">
            <LinkContent
              haveLink={haveLink}
              isDisabled={isDisabledByPermission}
              changeFormValue={change}
              getTestAttribute={getTestAttribute}
            />
          </Box>
        </Box>
        {isDisabledByPermission ? null : (
          <Box loose flex pr="2md" p="2md" className={styles.FormFooter}>
            <PrimaryButton
              className={styles.Buttons}
              onClick={handleSubmit}
              disabled={!dirty && Boolean(initialValues)}
            >
              {isNew ? `Создать` : `Сохранить`}
            </PrimaryButton>
            <Box loose pl="2md">
              <SecondaryButton
                className={styles.Buttons}
                onClick={dirty ? openConfirmationModal : onClose}
              >
                Отмена
              </SecondaryButton>
            </Box>
          </Box>
        )}
      </Box>
      {!isVirtual && <GridFields typeId={id} />}
      <ModalConfirm
        isOpen={isConfirmationModalOpen}
        title="Закрыть без сохранения?"
        buttonConf={[
          {
            text: `Закрыть`,
            onClick: dirty ? onClose : noop,
            isOk: true,
            done: true,
            disabled: false,
          },
          {
            text: `Отмена`,
            onClick: closeConfirmationModal,
            disabled: false,
          },
        ]}
        isClose
      >
        <div className={styles[`modal-message-wrapper`]}>
          <P className={styles[`modal-message-text`]}>
            Все сделанные вами изменения будут утеряны
          </P>
        </div>
      </ModalConfirm>
    </Box>
  )
})
